<template>
  <el-dialog
    title="Добавление группы пользователей"
    :visible.sync="dialogVisible"
    width="30%"
    center
    :before-close="closeDialog"
  >
    <el-form ref="form" :model="formData" :rules="rules">
      <el-form-item prop="title" label="Название группы">
        <el-input
          v-model="formData.title"
          :controls="false"
          type="text"
          placeholder="Введите название группы"
        />
      </el-form-item>
      <el-form-item>
        <span class="dialog-footer">
          <el-button type="primary" @click="createNewGroupHandler()">
            Добавить
          </el-button>
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { ADD_CONTRAGENT_GROUP } from '@/store/actions/contragentGroup'

export default {
  name: 'AddGroups',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formData: {
      id: '',
      title: '',
    },
    rules: {
      title: {
        required: true,
        message: 'Заполните название группы',
        trigger: 'blur',
      },
    },
  }),
  methods: {
    createNewGroupHandler() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.createNewGroup()
        }
      })
    },
    createNewGroup() {
      const item = {
        name: this.formData.title,
        user_org_inn:
          this.$store.getters['userProfile/userInfo'].current.organization.inn,
      }

      this.$store
        .dispatch(`${ADD_CONTRAGENT_GROUP}`, item)
        .then(() => this.closeDialog())
        .catch(e => console.log('e', e))
    },
    closeDialog() {
      this.$emit('close')
      this.clearForm()
    },
    clearForm() {
      this.formData = {}
      this.$refs['form'].clearValidate()
    },
  },
}
</script>
